/* =============================================================================
   ROSELYNA 2026 — moteur d'interaction
   Master Spec §11 (motion) · §20 (performance) · §30 (accessibilite)

   Un seul fichier, une seule mecanique de reveal pour tout le site.
   Aucune bibliotheque. Aucun polyfill. Rien qui bloque le rendu.
   ============================================================================= */
(function () {
  'use strict';

  var REDUIT = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------------
     REVEAL — §11
     Les elements portant data-rsl-reveal apparaissent a l'entree dans l'ecran.
     Ceux deja visibles au chargement s'ouvrent au premier frame : on n'inflige
     jamais un fondu a quelqu'un qui regarde deja l'element.
     --------------------------------------------------------------------------- */
  function reveal() {
    var els = document.querySelectorAll('[data-rsl-reveal]:not(.is-in)');
    if (!els.length) return;

    if (REDUIT || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(function (entrees, obs) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        obs.unobserve(e.target);           /* un reveal ne se rejoue jamais */
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });

    for (var j = 0; j < els.length; j++) {
      var el = els[j];
      if (el.getBoundingClientRect().top < innerHeight * 0.92) {
        requestAnimationFrame(el.classList.add.bind(el.classList, 'is-in'));
      } else {
        io.observe(el);
      }
    }
  }

  /* ---------------------------------------------------------------------------
     VIDEO — §22
     Aucune video ne se telecharge avant d'etre a l'ecran. L'attribut `autoplay`
     est INTERDIT dans le markup : il declenche le telechargement des le parsing
     du HTML, avant meme que ce script s'execute. Les sections posent
     data-rsl-autoplay ; c'est ici qu'on decide de lire.
     --------------------------------------------------------------------------- */
  function videos() {
    var vs = document.querySelectorAll('video[data-rsl-autoplay]:not([data-rsl-bound])');
    if (!vs.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.dataset.rslSrc && !v.src) v.src = v.dataset.rslSrc;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          try { v.pause(); } catch (err) {}   /* la pause arrete le buffer */
        }
      });
    }, { rootMargin: '200px 0px' });

    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      v.dataset.rslBound = '1';
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      if (!v.getAttribute('preload')) v.preload = 'metadata';
      io.observe(v);
    }
  }

  /* ---------------------------------------------------------------------------
     HEADER — §11 : transparent sur le hero, ivoire opaque au scroll.
     On ne lit le scroll qu'une fois par frame.
     --------------------------------------------------------------------------- */
  function header() {
    var h = document.querySelector('[data-rsl-header]');
    if (!h) return;
    var tick = false;
    function maj() {
      h.classList.toggle('is-solid', scrollY > 24);
      tick = false;
    }
    addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(maj); }
    }, { passive: true });
    maj();
  }

  /* ---------------------------------------------------------------------------
     DATA LAYER — §24
     Une seule fonction d'emission, pour que chaque section n'ait pas a connaitre
     le detail des outils. On pousse vers dataLayer (GTM) ET on emet un
     CustomEvent, ce qui permet de brancher Meta/CAPI plus tard sans retoucher
     les sections.
     --------------------------------------------------------------------------- */
  function emettre(nom, charge) {
    charge = charge || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: nom }, charge));
    document.dispatchEvent(new CustomEvent('rsl:' + nom, { detail: charge }));
  }
  window.rslTrack = emettre;

  /* les clics balises se declarent en HTML : data-rsl-event="hero_cta_click" */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-rsl-event]');
    if (!t) return;
    emettre(t.getAttribute('data-rsl-event'), {
      label: (t.textContent || '').trim().slice(0, 60),
      href: t.getAttribute('href') || null
    });
  }, true);

  /* --------------------------------------------------------------------------- */
  function demarrer() { reveal(); videos(); header(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* les sections injectees par l'editeur de theme doivent etre prises en charge */
  document.addEventListener('shopify:section:load', demarrer);
})();
